import React, { Component } from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import NavButton from "components/NavButton";
import { requestFindHcps } from 'modules/hcps/actions';
import Sidebar from "components/Sidebar"
import {
  Header,
  TablePlaceHolder
} from './components/SearchComponents';
import HcpTableItem from './components/HcpTableItem';
import SearchBar from 'view/components/SearchBar';

const initialPageSize = 50;
const pageSize = 20;
const bottomLoadHeight = 1200;

class Hcp extends Component {
  constructor() {
    super();
    this.state = {
      redirectTo: '',
      hcpsLoaded: false,
      stages: [],
      searchText: '',
      sortField: 'lastName',
      sortDirection: 1,
    };
  }

  componentWillMount = () => {
    console.log('component mounting');
    if (this.props.hcps.length > 0) {
      this.setState({ hcpsLoaded: true});
      return;
    }

    this.props.requestFindHcps({
      query: {
        limit: initialPageSize,
        skip: 0,
        stages: [],
        search: '',
        sortField: 'lastName',
        sortDirection: 1,
      },
      callback: () => this.setState({ hcpsLoaded: true }),
    });
  }

  redirect = (to) => this.props.history.push(to);

  render() {
    const hcps = this.props.hcps.list;
    const LengthToAdd = hcps.list ? (hcps.total - hcps.list.length) * 70 : 0;

    return (
      <main className="dashboard content-page" onScroll={this.onScroll}>
        <Sidebar />
        <div className="content">
          {/* <h1>Health Care Professionals</h1> */}
          <div className='search-container'>
            <div className="search-bar">
              <SearchBar
                tabIndex={200}
                width='187px'
                placeholder='Search...'
                msDebounce={300}
                onChange={async searchText => {
                  await this.setState({ searchText });
                  this.filterResults();
                }}
              />
            </div>

            <NavButton className="button-type-1" to='/hcp/create' style={{ marginRight: '40px', float: 'right' }}>+ Add HCPs</NavButton>

            <HcpTable>
              <Header />
              <div className='table-contents hcps'>
                <div style={{width: '100%', display:'table'}}>
                  {hcps.list && hcps.list.length > 0 ? hcps.list.map((hcp, index) => (
                    
                    <HcpTableItem
                      onClick={exclude(['a', 'button'], () => this.redirect(`/hcp/update?id=${hcp.id}`))}
                      tabIndex={300 + index}
                      key={index}
                      hcp={hcp}
                    />
                  )) : (
                    <TablePlaceHolder />
                  )}
                  <div style={{height: `${LengthToAdd}px`}}></div>
                </div>

              </div>
            </HcpTable>
          </div>
        </div>
      </main>
    )
  }

  onScroll = async e => {
    const hcps = this.props.hcps.list;
    const { hcpsLoaded } = this.state;
    if (hcps.listComplete) return;

    const currentFilledLength = hcps.list.length * 70; 
    const scrollPosition = e.target.offsetHeight + e.target.scrollTop;
    
    if (scrollPosition < currentFilledLength - bottomLoadHeight) return;
    
    if (hcpsLoaded) { //i.e. no currently pending calls to the DB
      this.setState({ hcpsLoaded: false });
      const { searchText, sortField, sortDirection, stages } = this.state;
      
      //if user scrolls past currently loaded point increase page size to load to that point in only one call
      let limit = pageSize;
      if (((scrollPosition / 70) - hcps.list.length) > pageSize) 
        limit = ((scrollPosition / 70) - hcps.list.length) + 10; // + 10 to account for extra scrolling during load
      
      this.props.requestFindHcps({
        query: {
          limit,
          skip: hcps.list.length,
          stages,
          search: searchText,
          sortField,
          sortDirection,
        },
        callback: () => {
          this.setState({ hcpsLoaded: true });
        }});  
    }
    
  }

  async filterResults() {
    const {searchText, stages, sortDirection, sortField} = this.state;
    this.props.requestFindHcps({
      query: {
        limit: initialPageSize,
        skip: 0,
        stages,
        search: searchText,
        sortField,
        sortDirection,
      },
    });
  }
}

const exclude = (exclusions, fn) => event => {
  if (!event.target.matches(exclusions)) {
    fn(event);
  }
};

const nullCheckedIncludes = (string, filter) =>
  string && string.toLowerCase().includes(filter.toLowerCase());

const excludeLinks = (event, fn) => {
  if (!event.target.matches('a')) {
    fn(event);
  }
}

const mapStateToProps = ({ hcps }) => ({ hcps });

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { requestFindHcps },
    dispatch
  );

const HcpTable = (props) => (
  <div className='default-table' {...props}>
  </div>
);

export const HeadRow = (props) => (
  <div className='table-head-row' {...props}>
  </div> 
);

export const Row = (props) => (
  <div className='table-row' {...props}>
  </div>
);

export const Cell = ({width, ...props}) => (
  <div className='table-cell' {...props} style={{width}}>
  </div>
);

const PlaceHolderRow = index => (
  <Row key={index}>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
    <Cell></Cell>
  </Row>
);  

export default connect(mapStateToProps, mapDispatchToProps)(Hcp);